

























import { defineComponent } from "@vue/composition-api";
import { ListFields } from "@/types";
import BaseIcon from "@/components/Base/BaseIcon";

export default defineComponent({
  name: "BaseInputRadio",
  components: { BaseIcon },
  props: {
    name: { type: String, default: "" },
    value: { type: [String, Boolean, Number], default: "" },
    options: { type: Array as () => ListFields, required: true },
    reverse: { type: Boolean, default: false },
    borderedItems: { type: Boolean, default: false },
  },
  methods: {
    onInput(value: any) {
      this.$emit("input", value);
    },
  },
});
